
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2022
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'createDashboardTitle': '创建仪表板',
	'dashboard': '仪表板',
	'dashboardTemplate': '仪表板模板',
	'createAV': '创建',
	'createAvEditNameLabel': '1. 对视图命名',
	'createAvSelectTemplateLabel': '2. 选择模板',
	'tabLayoutLabel': '选项卡式模板',
	'infographicsLayoutLabel': '信息图模板',
	'singlePageLayoutLabel': '单页面模板',
	'customLayoutLabel': '自定义模板',
	'freeformTemplate': '自由格式',
	'freeformTemplateDesc': '在自由格式布局中可视化的大小和位置与您在视图中调整的大小和放置位置完全一样，与屏幕大小无关。在其他布局中，可视化的大小和位置会调整以适应屏幕。',
	'NoTemplate': '自由格式',
	'Template1': '空白',
	'Template2': '标题 1 x 2',
	'Template3': '2（上方图表），1（下方图表）',
	'Template4': '4（上方图表），1（下方图表）',
	'Template5': '页脚 1 x 2',
	'Template6': '3 与 1 并列（上方图表），1（下方图表）',
	'Template7': '4 与 3 并列（上方图表），1（下方图表）',
	'Template8': '2（上方图表），3 x 2（下方图表）',
	'Template9': '2 x 2',
	'Template10': '1 x 2 与 2 x 2 并列（上方图表），1（下方图表）',
	'Template11': '3 x 1（上方图表），1 x 2（下方图表）',
	'Template12': '2（上方图表），1 与 1 x 2 并列（下方图表）',
	'Template13': '1 与 1 x 2 并列，与 1 x 4 并列',
	'Template14': '放置区空白',
	'Infographics1': '空白',
	'Infographics2': '4 行',
	'Infographics3': '4 行，带标题',
	'Infographics4': '2 x 4',
	'Infographics5': '大型顶部显示 (2 x 2)',
	'Infographics6': '2 x 4（含垂直间距）',
	'Infographics7': '2 x 4（交错）',
	'Infographics8': '网球场',
	'Infographics9': '3 x 4',
	'Infographics10': '4 x 8',
	'createAvDashboardLabel': '布局',
	'dashboard_template_save_success': '您的仪表板模板已保存。',
	'dashboard_template_prefix': '模板：\'%{name}\'',
	'dashboard_template_filters_removed': '画布上的过滤器已成功移除。',
	'createAvTabLabel': '选项卡式',
	'createAvInfographicsLabel': '信息图',
	'createAvSinglepageLabel': '单页面',
	'createAvCustomLabel': '自定义',
	'loadMoreLabel': '装入更多...',
	'backLabel': '返回',
	'addSourceLabel': '添加源',
	'pinLabel': '置顶',
	'errorLoadingDataSetMetaData': '读取元数据时出错',
	'errorLoadingDataSets': '装入数据集列表时出错',
	'errorLoadingDataSet': '未装入数据集“%{datasetName}”的元数据。请联系您的管理员以获取详细信息。',
	'okButton': '确定',
	'createButton': '创建',
	'cancelButton': '取消',
	'copyButton': '复制',
	'selectTemplateLabel': '选择模板',
	'noSourcesSelectedLabel': '未选择任何源',
	'find_label': '查找',
	'noDashboardFound': '无法检索到仪表板。它不再存在，或者您没有足够的权限进行查看。',
	'errorLabel': '错误',
	'defaultName': '新仪表板',
	'noDashboardCapability': '您无权运行仪表板应用程序。',
	'noCapabilityForEdit': '您无法编辑此仪表板',
	'noCapabilityForSave': '您无法保存此仪表板',
	'noCapabilityForPaste': '您无法在此视图中粘贴所复制的窗口小部件',
	'noCapabilityForPin': '您无法添加此固定项',
	'noDashboardPermission': '您没有足够的特权来查看此仪表板',
	'sourceNotFound': '无法装入可视化，因为其关联的源“%{sourceName}”不可用',
	'cmDuplicateName': '具有此名称的项已存在。请尝试其他名称',
	'cmEmptySelection': '仪表板已删除。请尝试另存为新仪表板。',
	'propTheme': '可视主题',
	'defaultThemeLabel': '默认',
	'lightThemeLabel': '浅',
	'darkThemeLabel': '深',
	'titleTextLabel': '标题',
	'titleSmallTextLabel': '标题（小）',
	'subtitleTextLabel': '副标题',
	'bodyTextLabel': '正文',
	'bodySmallTextLabel': '正文（小）',
	'captionTextLabel': '标题',
	'quoteTextLabel': '引用',
	'quoteSmallTextLabel': '引用（小）',
	'responsiveTextLabel': '自动调整大小',
	'mediaWidgetLabel': '媒体',
	'webpageWidgetLabel': 'Web 页面',
	'imageWidgetLabel': '图像',
	'textWidgetLabel': '文本',
	'notebookWidgetLabel': '笔记本',
	'multipurposeWidgetLabel': '多用途',
	'textPlaceHolder': '在此处输入文本',
	'titlePlaceHolder': '在此处输入标题',
	'toggleEditModeLabel': '切换以进行编辑',
	'togglePreviewModeLabel': '切换以进行预览',
	'editDashboardCoachMarkTitle': '编辑仪表板',
	'editDashboardCoachMarkContents': '单击画笔图标以编辑此仪表板。',
	'addDataCoachMarkTitle': '添加数据',
	'addDataDashboardCoachMarkContents': '将数据从数据面板拖放到仪表板上。',
	'pageSelectWarning': '请选择选项卡。',
	'screenshot_label': '仪表板 %{title}',
	'screenshot_label_tab': '仪表板 %{title} 的选项卡 %{tabName}',
	'dataAssetPropertiesLabel': '可视化属性',
	'modelFilter': '过滤器',
	'invertSelectionToolTip': '反向过滤器选项',
	'clearFilterValueToolTip': '清除过滤器值',
	'invertFilterSelection': '反转',
	'clearTextFilterValue': '清除',
	'filterConditionLabel': '过滤条件',
	'applyFilter': '应用过滤器',
	'itemCountText': '已选择 %{itemCount} 项',
	'itemExcludeCountText': '已排除 %{itemCount} 项',
	'moreMembers': '显示更多内容...',
	'searchHierarchyMembers': '使用搜索查找成员...',
	'propHideEmpty': '隐藏空值',
	'propColorOrder': '颜色顺序',
	'propElementColor': '可视化元素颜色',
	'propLineColor': '线条颜色',
	'propLineAndSymbolColor': '线条和符号颜色',
	'propColumnColor': '列颜色',
	'propBarColor': '条形颜色',
	'propWordColor': '字颜色',
	'propAreaColor': '区域颜色',
	'propRadialbarColor': '径向条形颜色',
	'propColorPalettes': '调色板',
	'propDashboardColorPalette': '当前仪表板调色板',
	'propNewDashboardPaletteLabel': '创建自定义仪表板调色板',
	'propDashboardChangePaletteLink': '更改仪表板调色板',
	'propHideLeafNode': '隐藏前导标签',
	'propOpacity': '不透明',
	'propOpacityDescription': '使对象更不透明或更透明。请输入介于 0 和 100 之间的值',
	'addATab': '添加新选项卡',
	'propFredIsRed': '颜色一致性',
	'areaChartCaption': '面积图',
	'areaChartDataSlot_categoriesLabel': '轴标',
	'areaChartDataSlot_valuesLabel': '值',
	'areaChartProp_colorPaletteLabel': '调色板',
	'areaChartProp_lineColorLabel': '区域颜色',
	'areaChartProp_interpolationLabel': '平滑线条',
	'areaChartProp_interpolationDescription': '连接数据点的线条为曲线。',
	'areaChartProp_hideGridLinesLabel': '隐藏网格线',
	'areaChartProp_hideGridLinesDescription': '隐藏网格线',
	'areaChartProp_hideAxisTitleLabelsLabel': '隐藏轴名标签',
	'areaChartProp_hideAxisTitleLabelsDescription': '隐藏轴名。',
	'areaChartProp_maintainAxisScalesLabel': '保持轴刻度',
	'areaChartProp_maintainAxisScalesDescription': '始终在轴上显示最小值和最大值。',
	'areaChartProp_suppressZerosLabel': '隐藏空值',
	'areaChartProp_suppressZerosDescription': '隐藏没有关联值的类别。',
	'barChartCaption': '条形图',
	'barChartDataSlot_categoriesLabel': '轴标',
	'barChartDataSlot_valuesLabel': '值',
	'barChartProp_colorPaletteLabel': '调色板',
	'barChartProp_elementColorLabel': '条形颜色',
	'barChartProp_hideGridLinesLabel': '隐藏网格线',
	'barChartProp_hideGridLinesDescription': '隐藏网格线',
	'barChartProp_hideAxisTitleLabelsLabel': '隐藏轴名标签',
	'barChartProp_hideAxisTitleLabelsDescription': '隐藏轴名。',
	'barChartProp_maintainAxisScalesLabel': '保持轴刻度',
	'barChartProp_maintainAxisScalesDescription': '始终在轴上显示最小值和最大值。',
	'barChartProp_suppressZerosLabel': '隐藏空值',
	'barChartProp_suppressZerosDescription': '隐藏没有关联值的类别。',
	'columnChartCaption': '柱形图',
	'columnChartDataSlot_categoriesLabel': '轴标',
	'columnChartDataSlot_valuesLabel': '值',
	'columnChartProp_colorPaletteLabel': '调色板',
	'columnChartProp_elementColorLabel': '列颜色',
	'columnChartProp_hideGridLinesLabel': '隐藏网格线',
	'columnChartProp_hideGridLinesDescription': '隐藏网格线',
	'columnChartProp_hideAxisTitleLabelsLabel': '隐藏轴名标签',
	'columnChartProp_hideAxisTitleLabelsDescription': '隐藏轴名。',
	'columnChartProp_maintainAxisScalesLabel': '保持轴刻度',
	'columnChartProp_maintainAxisScalesDescription': '始终在轴上显示最小值和最大值。',
	'columnChartProp_suppressZerosLabel': '隐藏空值',
	'columnChartProp_suppressZerosDescription': '隐藏没有关联值的类别。',
	'bubbleChartCaption': '气泡图',
	'bubbleChartDataSlot_xAxisLabel': '水平轴',
	'bubbleChartDataSlot_yAxisLabel': '垂直轴',
	'bubbleChartDataSlot_sizeLabel': '大小依据',
	'bubbleChartDataSlot_colorLabel': '着色依据',
	'bubbleChartProp_colorPaletteLabel': '调色板',
	'bubbleChartProp_hideGridLinesLabel': '隐藏网格线',
	'bubbleChartProp_hideGridLinesDescription': '隐藏网格线',
	'bubbleChartProp_hideAxisTitleLabelsLabel': '隐藏轴名标签',
	'bubbleChartProp_hideAxisTitleLabelsDescription': '隐藏轴名。',
	'bubbleChartProp_maintainAxisScalesLabel': '保持轴刻度',
	'bubbleChartProp_maintainAxisScalesDescription': '始终在轴上显示最小值和最大值。',
	'bubbleChartProp_hideLegendLabel': '隐藏图注',
	'bubbleChartProp_hideLegendDescription': '隐藏图注。',
	'bubbleChartProp_legendPositionLabel': '图注位置',
	'lineChartCaption': '折线图',
	'lineChartDataSlot_categoriesLabel': '轴标',
	'lineChartDataSlot_valuesLabel': '值',
	'lineChartProp_colorPaletteLabel': '调色板',
	'lineChartProp_lineColorLabel': '线条和符号颜色',
	'lineChartProp_symbolShapeLabel': '符号形状',
	'lineChartProp_hideSymbolsLabel': '隐藏符号',
	'lineChartProp_hideSymbolsDescription': '隐藏符号',
	'lineChartProp_hideDataLinesLabel': '隐藏线条',
	'lineChartProp_hideDataLinesDescription': '隐藏线条',
	'lineChartProp_interpolationLabel': '平滑线条',
	'lineChartProp_interpolationDescription': '连接数据点的线条为曲线。',
	'lineChartProp_hideGridLinesLabel': '隐藏网格线',
	'lineChartProp_hideGridLinesDescription': '隐藏网格线',
	'lineChartProp_hideAxisTitleLabelsLabel': '隐藏轴名标签',
	'lineChartProp_hideAxisTitleLabelsDescription': '隐藏轴名。',
	'lineChartProp_maintainAxisScalesLabel': '保持轴刻度',
	'lineChartProp_maintainAxisScalesDescription': '始终在轴上显示最小值和最大值。',
	'lineChartProp_suppressZerosLabel': '隐藏空值',
	'lineChartProp_suppressZerosDescription': '隐藏没有关联值的类别。',
	'packedBubbleChart1CatCaption': '压缩气泡图',
	'packedBubbleChart1CatDataSlot_categoriesLabel': '类别',
	'packedBubbleChart1CatDataSlot_sizeLabel': '大小依据',
	'packedBubbleChart1CatProp_colorPaletteLabel': '调色板',
	'packedBubbleChart1CatProp_elementColorLabel': '气泡颜色',
	'packedBubbleChart1CatProp_hideLabelLabel': '隐藏标签',
	'packedBubbleChart1CatProp_hideValueLabel': '隐藏值',
	'packedBubbleChart1CatProp_maintainAxisScalesLabel': '保持轴刻度',
	'packedBubbleChart1CatProp_maintainAxisScalesDescription': '始终在轴上显示最小值和最大值。',
	'packedBubbleChart1CatProp_suppressZerosLabel': '隐藏空值',
	'packedBubbleChart1CatProp_suppressZerosDescription': '隐藏没有关联值的类别。',
	'heatChartCaption': '热图',
	'heatChartDataSlot_valuesLabel': '热度依据',
	'heatChartDataSlot_xAxisLabel': '水平轴',
	'heatChartDataSlot_yAxisLabel': '垂直轴',
	'heatChartProp_colorPaletteLabel': '调色板',
	'heatChartProp_heatScalePaletteLabel': '颜色顺序',
	'heatChartProp_hideAxisTitleLabelsLabel': '隐藏轴名标签',
	'heatChartProp_hideAxisTitleLabelsDescription': '隐藏轴名。',
	'heatChartProp_maintainAxisScalesLabel': '保持轴刻度',
	'heatChartProp_maintainAxisScalesDescription': '始终在轴上显示最小值和最大值。',
	'heatChartProp_suppressZerosLabel': '隐藏空值',
	'heatChartProp_suppressZerosDescription': '隐藏没有关联值的类别。',
	'heatChartProp_hideLegendLabel': '隐藏图注',
	'heatChartProp_hideLegendDescription': '隐藏图注。',
	'heatChartProp_legendPositionLabel': '图注位置',
	'pieChartCaption': '饼形图',
	'pieChartDataSlot_categoriesLabel': '类别',
	'pieChartDataSlot_valuesLabel': '值',
	'pieChartProp_colorPaletteLabel': '调色板',
	'pieChartProp_hideRadialValueLabel': '隐藏值',
	'pieChartProp_pieAsDonutLabel': '显示为圆环图',
	'pieChartProp_pieAsDonutDescription': '显示为圆环图',
	'pieChartProp_suppressZerosLabel': '隐藏空值',
	'pieChartProp_suppressZerosDescription': '隐藏没有关联值的类别。',
	'pieChartProp_hideLegendLabel': '隐藏图注',
	'pieChartProp_hideLegendDescription': '隐藏图注。',
	'pieChartProp_legendPositionLabel': '图注位置',
	'map1measureCaption': '地图',
	'map1measureDataSlot_categoriesLabel': '区域',
	'map1measureDataSlot_valuesLabel': '区域热度',
	'map1measureProp_colorPaletteLabel': '调色板',
	'map1measureProp_heatScalePaletteLabel': '颜色顺序',
	'map1measureProp_maintainAxisScalesLabel': '保持轴刻度',
	'map1measureProp_maintainAxisScalesDescription': '始终在轴上显示最小值和最大值。',
	'map1measureProp_suppressZerosLabel': '隐藏空值',
	'map1measureProp_suppressZerosDescription': '隐藏没有关联值的类别。',
	'map1measureProp_hideLegendLabel': '隐藏图注',
	'map1measureProp_hideLegendDescription': '隐藏图注。',
	'map1measureProp_legendPositionLabel': '图注位置',
	'radialChartCaption': '径向图',
	'radialChartDataSlot_categoriesLabel': '类别',
	'radialChartDataSlot_valuesLabel': '值',
	'radialChartProp_colorPaletteLabel': '调色板',
	'radialChartProp_elementColorLabel': '径向条形颜色',
	'radialChartProp_hideRadialTitleLabel': '隐藏标题',
	'radialChartProp_hideRadialValueLabel': '隐藏值',
	'radialChartProp_maintainAxisScalesLabel': '保持轴刻度',
	'radialChartProp_maintainAxisScalesDescription': '始终在轴上显示最小值和最大值。',
	'radialChartProp_suppressZerosLabel': '隐藏空值',
	'radialChartProp_suppressZerosDescription': '隐藏没有关联值的类别。',
	'pointChart1catCaption': '点状图',
	'pointChart1catDataSlot_valuesLabel': '值',
	'pointChart1catDataSlot_categoriesLabel': '轴标',
	'pointChart1catProp_colorPaletteLabel': '调色板',
	'pointChart1catProp_elementColorLabel': '形状颜色',
	'pointChart1catProp_symbolShapeLabel': '符号形状',
	'pointChart1catProp_symbolFillLabel': '填充形状',
	'pointChart1catProp_symbolFillDescription': '显示符号的填充颜色。',
	'pointChart1catProp_hideGridLinesLabel': '隐藏网格线',
	'pointChart1catProp_hideGridLinesDescription': '隐藏网格线',
	'pointChart1catProp_hideAxisTitleLabelsLabel': '隐藏轴名标签',
	'pointChart1catProp_hideAxisTitleLabelsDescription': '隐藏轴名。',
	'pointChart1catProp_maintainAxisScalesLabel': '保持轴刻度',
	'pointChart1catProp_maintainAxisScalesDescription': '始终在轴上显示最小值和最大值。',
	'pointChart1catProp_suppressZerosLabel': '隐藏空值',
	'pointChart1catProp_suppressZerosDescription': '隐藏没有关联值的类别。',
	'scatterPlotChartNoCatCaption': '散点图',
	'scatterPlotChartNoCatDataSlot_xAxisLabel': '水平轴',
	'scatterPlotChartNoCatDataSlot_yAxisLabel': '垂直轴',
	'scatterPlotChartNoCatProp_colorPaletteLabel': '调色板',
	'scatterPlotChartNoCatProp_elementColorLabel': '元素颜色',
	'scatterPlotChartNoCatProp_symbolShapeLabel': '符号形状',
	'scatterPlotChartNoCatProp_symbolFillLabel': '填充形状',
	'scatterPlotChartNoCatProp_symbolFillDescription': '显示符号的填充颜色。',
	'scatterPlotChartNoCatProp_hideGridLinesLabel': '隐藏网格线',
	'scatterPlotChartNoCatProp_hideGridLinesDescription': '隐藏网格线',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsLabel': '隐藏轴名标签',
	'scatterPlotChartNoCatProp_hideAxisTitleLabelsDescription': '隐藏轴名。',
	'radialBarChartCaption': '径向条形图',
	'radialBarChartDataSlot_categoriesLabel': '类别',
	'radialBarChartDataSlot_valuesLabel': '值',
	'radialBarChartProp_colorPaletteLabel': '调色板',
	'radialBarChartProp_elementColorLabel': '径向条形颜色',
	'radialBarChartProp_hideRadialTitleLabel': '隐藏标题',
	'radialBarChartProp_maintainAxisScalesLabel': '保持轴刻度',
	'radialBarChartProp_maintainAxisScalesDescription': '始终在轴上显示最小值和最大值。',
	'radialBarChartProp_suppressZerosLabel': '隐藏空值',
	'radialBarChartProp_suppressZerosDescription': '隐藏没有关联值的类别。',
	'lineColumnComboChartCaption': '柱形折线图',
	'lineColumnComboChartDataSlot_categoryLabel': '轴标',
	'lineColumnComboChartDataSlot_lineValueLabel': '线条值',
	'lineColumnComboChartDataSlot_columnValueLabel': '柱形值',
	'lineColumnComboChartProp_colorPaletteLabel': '调色板',
	'lineColumnComboChartProp_elementColorLabel': '列颜色',
	'lineColumnComboChartProp_lineColorLabel': '线条和符号颜色',
	'lineColumnComboChartProp_symbolShapeLabel': '符号形状',
	'lineColumnComboChartProp_hideSymbolsLabel': '隐藏符号',
	'lineColumnComboChartProp_hideSymbolsDescription': '隐藏符号',
	'lineColumnComboChartProp_hideDataLinesLabel': '隐藏线条',
	'lineColumnComboChartProp_hideDataLinesDescription': '隐藏线条',
	'lineColumnComboChartProp_interpolationLabel': '平滑线条',
	'lineColumnComboChartProp_interpolationDescription': '连接数据点的线条为曲线。',
	'lineColumnComboChartProp_hideGridLinesLabel': '隐藏网格线',
	'lineColumnComboChartProp_hideGridLinesDescription': '隐藏网格线',
	'lineColumnComboChartProp_hideAxisTitleLabelsLabel': '隐藏轴名标签',
	'lineColumnComboChartProp_hideAxisTitleLabelsDescription': '隐藏轴名。',
	'lineColumnComboChartProp_maintainAxisScalesLabel': '保持轴刻度',
	'lineColumnComboChartProp_maintainAxisScalesDescription': '始终在轴上显示最小值和最大值。',
	'lineColumnComboChartProp_suppressZerosLabel': '隐藏空值',
	'lineColumnComboChartProp_suppressZerosDescription': '隐藏没有关联值的类别。',
	'lineColumnComboChartProp_hideLegendLabel': '隐藏图注',
	'lineColumnComboChartProp_hideLegendDescription': '隐藏图注。',
	'lineColumnComboChartProp_legendPositionLabel': '图注位置',
	'summaryCaption': '汇总',
	'areaName': '面积图',
	'areaDescription': '面积图',
	'areaDataSlot_colorLabel': '着色依据',
	'areaDataSlot_valuesLabel': '值',
	'areaDataSlot_categoriesLabel': '轴标',
	'bubbleName': '气泡图',
	'bubbleDescription': '气泡图',
	'bubbleDataSlot_yAxisLabel': '垂直轴',
	'bubbleDataSlot_xAxisLabel': '水平轴',
	'bubbleDataSlot_sizeLabel': '大小依据',
	'bubbleDataSlot_colorLabel': '着色依据',
	'clusterBarName': '条形图',
	'clusterBarDescription': '条形图',
	'clusterBarDataSlot_colorLabel': '着色依据',
	'clusterBarDataSlot_valuesLabel': '值',
	'clusterBarDataSlot_categoriesLabel': '轴标',
	'clusterBarDataSlot_valuesRepeatingLabel': '值',
	'clusterColumnName': '柱形图',
	'clusterColumnDescription': '柱形图',
	'clusterColumnDataSlot_colorLabel': '着色依据',
	'clusterColumnDataSlot_valuesLabel': '值',
	'clusterColumnDataSlot_categoriesLabel': '轴标',
	'clusterColumnDataSlot_valuesRepeatingLabel': '值',
	'clusterLineName': '折线图',
	'clusterLineDescription': '折线图',
	'clusterLineDataSlot_colorLabel': '着色依据',
	'clusterLineDataSlot_valuesLabel': '垂直轴',
	'clusterLineDataSlot_categoriesLabel': '水平轴',
	'clusterLineDataSlot_valuesRepeatingLabel': '值',
	'gridName': '网格',
	'gridDescription': '网格',
	'gridDataSlot_grid_colsLabel': '柱形图',
	'heatName': '热图',
	'heatDescription': '热图',
	'heatDataSlot_yAxisLabel': '垂直轴',
	'heatDataSlot_xAxisLabel': '水平轴',
	'heatDataSlot_valuesLabel': '热度依据',
	'lineColumnComboName': '柱形折线图',
	'lineColumnComboDescription': '柱形折线图',
	'lineColumnComboDataSlot_lineValueLabel': '线条值',
	'lineColumnComboDataSlot_categoryLabel': '轴标',
	'lineColumnComboDataSlot_columnValueLabel': '柱形值',
	'mapName': '原有地图',
	'mapDescription': '原有地图',
	'mapDataSlot_sizeLabel': '点大小',
	'mapDataSlot_valuesLabel': '区域热度',
	'mapDataSlot_sizeHeatLabel': '点热度',
	'mapDataSlot_categoriesLabel': '区域',
	'packedBubbleName': '压缩气泡图',
	'packedBubbleDescription': '压缩气泡图',
	'packedBubbleDataSlot_sizeLabel': '大小依据',
	'packedBubbleDataSlot_colorLabel': '着色依据',
	'packedBubbleDataSlot_categoriesLabel': '类别',
	'pieName': '饼形图',
	'pieDescription': '饼形图',
	'pieDataSlot_valuesLabel': '值',
	'pieDataSlot_categoriesLabel': '类别',
	'playerName': '数据播放器',
	'playerDescription': '数据播放器',
	'playerDataSlot_categoriesLabel': '轴标',
	'pointName': '点状图',
	'pointDescription': '点状图',
	'pointDataSlot_colorLabel': '着色依据',
	'pointDataSlot_valuesLabel': '值',
	'pointDataSlot_categoriesLabel': '轴标',
	'radialName': '径向图',
	'radialDescription': '径向图',
	'radialDataSlot_valuesLabel': '值',
	'radialDataSlot_maxSizeLabel': '最大值',
	'radialDataSlot_categoriesLabel': '类别',
	'radialBarName': '径向条形图',
	'radialBarDescription': '径向条形图',
	'radialBarDataSlot_valuesLabel': '值',
	'radialBarDataSlot_categoriesLabel': '类别',
	'scatterPlotName': '散点图',
	'scatterPlotDescription': '散点图',
	'scatterPlotDataSlot_yAxisLabel': '垂直轴',
	'scatterPlotDataSlot_xAxisLabel': '水平轴',
	'scatterPlotDataSlot_colorLabel': '着色依据',
	'scatterPlotDataSlot_categoriesLabel': '点',
	'stackedBarName': '堆积条形图',
	'stackedBarDescription': '堆积条形图',
	'stackedBarDataSlot_colorLabel': '着色依据',
	'stackedBarDataSlot_valuesLabel': '值',
	'stackedBarDataSlot_categoriesLabel': '轴标',
	'stackedBarDataSlot_valuesRepeatingLabel': '值',
	'stackedColumnName': '堆积柱形图',
	'stackedColumnDescription': '堆积柱形图',
	'stackedColumnDataSlot_colorLabel': '着色依据',
	'stackedColumnDataSlot_valuesLabel': '值',
	'stackedColumnDataSlot_categoriesLabel': '轴标',
	'stackedColumnDataSlot_valuesRepeatingLabel': '值',
	'summaryChartName': '汇总',
	'summaryChartDescription': '汇总',
	'summaryChartDataSlot_valuesLabel': '值',
	'treeMapName': '树状图',
	'treeMapDescription': '树状图',
	'treeMapDataSlot_colorLabel': '热度依据',
	'treeMapDataSlot_valuesLabel': '大小依据',
	'treeMapDataSlot_categoriesLabel': '第一级',
	'treeMapDataSlot_level3Label': '第三级',
	'treeMapDataSlot_level2Label': '第二级',
	'wordCloudName': '字云',
	'wordCloudDescription': '字云',
	'wordCloudDataSlot_colorLabel': '着色依据',
	'wordCloudDataSlot_scaleLabel': '大小依据',
	'wordCloudDataSlot_wordLabel': '字',
	'treeMap1Cat1MeasureChartCaption': '树状图',
	'treeMap1Cat1MeasureChartDataSlot_categoriesLabel': '第一级',
	'treeMap1Cat1MeasureChartDataSlot_valuesLabel': '大小依据',
	'treeMap1Cat1MeasureChartProp_colorPaletteLabel': '调色板',
	'treeMap1Cat2MeasureChartProp_colorPaletteLabel': '调色板',
	'treeMap2Cat1MeasureChartProp_colorPaletteLabel': '调色板',
	'treeMap2Cat2MeasureChartProp_colorPaletteLabel': '调色板',
	'treeMap3Cat1MeasureChartProp_colorPaletteLabel': '调色板',
	'treeMap3Cat2MeasureChartProp_colorPaletteLabel': '调色板',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesLabel': '保持轴刻度',
	'treeMap1Cat1MeasureChartProp_maintainAxisScalesDescription': '始终在轴上显示最小值和最大值。',
	'treeMap1Cat1MeasureChartProp_suppressZerosLabel': '隐藏空值',
	'treeMap1Cat1MeasureChartProp_suppressZerosDescription': '隐藏没有关联值的类别。',
	'treeMap1Cat1MeasureChartProp_hideLegendLabel': '隐藏图注',
	'treeMap1Cat1MeasureChartProp_hideLegendDescription': '隐藏图注。',
	'treeMap1Cat1MeasureChartProp_legendPositionLabel': '图注位置',
	'wordChart1Cat1MeasureCaption': '字云',
	'wordChart1Cat1MeasureDataSlot_wordLabel': '字',
	'wordChart1Cat1MeasureDataSlot_scaleLabel': '大小依据',
	'wordChart1Cat1MeasureProp_colorPaletteLabel': '调色板',
	'wordChart1Cat1MeasureProp_elementColorLabel': '字颜色',
	'wordChart1Cat1MeasureProp_maintainAxisScalesLabel': '保持轴刻度',
	'wordChart1Cat1MeasureProp_maintainAxisScalesDescription': '始终在轴上显示最小值和最大值。',
	'wordChart1Cat1MeasureProp_suppressZerosLabel': '隐藏空值',
	'wordChart1Cat1MeasureProp_suppressZerosDescription': '隐藏没有关联值的类别。',
	'missingDataSetData': '此数据集的数据不可用。请刷新此数据集，或联系管理员以获取对该源的访问权。',
	'hideShowSummaries': '隐藏显示摘要',
	'crosstabName': '交叉表',
	'value_is_not_available': '不适用',
	'swapRowsAndColumns': '交换行和列',
	'NoPinsCollected': '无置顶的可视化',
	'pinSearchOld': '搜索我的置顶',
	'pinDeletedToast': '已移除置顶',
	'pinAddedToast': '已成功将置顶添加到“我的置顶”',
	'pinRetrieveError': '无法检索一个或多个置顶。请稍后再试。',
	'pinErrorTitle': '置顶错误',
	'pinRemove': '除去置顶',
	'deletePin': '删除置顶',
	'dataset_time': '时间',
	'dataset_date': '日期',
	'dataset_location': '位置',
	'dataset_number': '数字',
	'dataset_text': '文本',
	'widgetConditionalFormatLabel': '切换条件格式控件',
	'deletePinConfirmationMessage': '确定要删除此置顶吗？此操作无法撤销。',
	'deletePinConfirm': '确认删除',
	'pinDeleteError': '无法删除一个或多个置顶。请稍后再试。',
	'conditionalPalettePickerLabel': '%{title} 值的分布',
	'HistogramYAxisTitle': '计数',
	'metadataPickerTitle': '创建数据集',
	'moreTitle': '更多',
	'remove_slider_handle': '移除手柄',
	'missingFiltering': '缺失列：',
	'unSupportedPromptType': '当前不支持提示方案。',
	'preAggregateLabel': '应用数据源中的提示值',
	'postAggregateLabel': '在报表中应用提示值',
	'preAggregateText': '该范围使用数据源中的值，而不是仪表板中显示的值。',
	'tabName_general': '常规',
	'tabName_visDetails': '详细信息',
	'tabName_textDetails': '文本详细信息',
	'tabName_mediaDetails': '媒体详细信息',
	'tabName_webDetails': 'Web 页面详细信息',
	'tabName_imageDetails': '图像详细信息',
	'tabName_visualization': '可视化',
	'sectionName_canvas': '画布',
	'sectionName_colorsAndThemes': '颜色和主题',
	'sectionName_appearance': '外观',
	'sectionName_advanced': '高级',
	'sectionName_layout': '布局',
	'sectionName_tabs': '选项卡',
	'sectionName_tabTitle': '标签',
	'sectionName_tabBackground': '背景',
	'addDataSourceDialogTitle': '添加数据源',
	'addDataSourceDialogButtonLabel': '添加',
	'shapesDoubleChevron': '双脱字符号',
	'widgetsPanelTitle': '窗口小部件',
	'widgetsPanelImageLibraryTab': '图像库',
	'widgetsPanelSectionBasic': '基本',
	'widgetsPanelSectionAdvanced': '高级',
	'widgetsPanelSectionShapes': '形状',
	'customWidgetsTitle': '自定义窗口小部件',
	'filterItemCanvasMove': '添加到画布',
	'filterOverflowMenu_Global': '所有选项卡溢出菜单',
	'filterOverflowMenu_Tab': '此选项卡溢出菜单',
	'filterOverflowMenu_Item': '过滤器溢出菜单',
	'filterOverflowMenu_Single': '溢出菜单',
	'filterItemEdit': '编辑过滤器值',
	'filterDeleteAllItems': '删除所有过滤器',
	'filterClearAllItems': '清除所有过滤器',
	'filterClearSelection': '清除过滤器',
	'filterPlayerMode': '显示播放器',
	'filterStaticMode': '显示列表',
	'filterInvertSelection': '反转过滤器',
	'filterIconLabel_Global': '所有选项卡',
	'filterIconLabel_Single': '过滤器',
	'filterIconLabel_Tab': '此选项卡',
	'filterIconTooltip_Global': '所有选项卡',
	'filterIconTooltip_Tab': '此选项卡',
	'filterIconTooltip_Single': '过滤器',
	'filterItemDelete': '删除过滤器',
	'filterValueSeparator': ',',
	'filterRange': '%{from} 到 %{to}',
	'filterInvertRange': '除以下项外的所有项：%{from} 到 %{to}',
	'filterExcept': '除 %{values} 外',
	'filterAll': '全部',
	'filterBlank': '（空白）',
	'filterDisableRangeInvert': '此列在“所有选项卡”过滤器中时不可用。',
	'filterDisableHierarchyInvert': '此列在层级过滤器中时不可用。',
	'filterSelectedOfTotal': '%{selected} 个（共 %{totalMembers} 个）',
	'filter_date_before': '在 %{to} 之前',
	'filter_date_before_except': '不在 %{to} 之前',
	'filter_date_after': '在 %{from} 之后',
	'filter_date_after_except': '不在 %{from} 之后',
	'filter_date_between': '%{from} 到 %{to} 之间',
	'filter_date_between_except': '不在 %{from} 到 %{to} 之间',
	'filter_drag_and_drop_all_tabs': '将数据拖放到此处以过滤所有选项卡。',
	'filter_drag_and_drop_current_tab': '将数据拖放到此处以过滤此选项卡。',
	'filter_drag_and_drop_single_dock': '将数据拖放到此处以进行过滤。',
	'errMsgFilterItemGenericTitle': '无法装入过滤器值',
	'widgetChromeRotate': '旋转',
	'toolbarRegionLabel': '工具栏',
	'toolbarActionDelete': '删除',
	'toolbarActionGroup': '分组',
	'toolbarActionUngroup': '取消分组',
	'toolbarActionOrderToFront': '前置',
	'toolbarActionOrderToBack': '后置',
	'toolbarActionEditTitle': '编辑标题',
	'toolbarActionWrapTitle': '换行标题',
	'toolbarActionPin': '收集',
	'toolbarActionPinOld': '置顶',
	'toolbarActionAlign': '对齐',
	'alignWidgetLeft': '左侧',
	'alignWidgetCenter': '居中',
	'alignWidgetRight': '右侧',
	'alignWidgetTop': '顶部',
	'alignWidgetMiddle': '居中',
	'alignWidgetBottom': '底部',
	'toolbarChangeVisualization': '更改可视化',
	'live_label': '图表',
	'filter_label': '过滤器',
	'one_named_live': '%{name} 图表',
	'one_named_live_numbered': '%{name} 图表（%{number} 个）',
	'one_unknown_live': '图表',
	'one_unknown_live_numbered': '图表（%{number} 个）',
	'few_live': '包含 %{count} 个图表的组',
	'many_live': '包含 %{count} 个图表的组',
	'one_custom': '自定义窗口小部件',
	'one_custom_named': '%{name}',
	'one_custom_named_numbered': '%{name} (%{number})',
	'one_named_filter': '%{name} 过滤器',
	'one_named_filter_numbered': '%{name} 过滤器（%{number} 个）',
	'one_unknown_filter': '过滤器',
	'one_unknown_filter_numbered': '过滤器（%{number} 个）',
	'few_filter': '包含 %{count} 个过滤器的组',
	'many_filter': '包含 %{count} 个过滤器的组',
	'LIVE_bar_has_mapping': '%{values} 条形图',
	'LIVE_bar_has_mapping_numbered': '%{values} 条形图（%{number} 个）',
	'LIVE_bar_opt_mapping': '%{categories}（按 %{values} 条形图）',
	'LIVE_bar_opt_mapping_numbered': '%{categories}（按 %{values} 条形图（%{number} 个））',
	'LIVE_bar_no_mapping': '空条形图',
	'LIVE_bar_no_mapping_numbered': '空条形图（%{number} 个）',
	'LIVE_bar_named': '%{name} 条形图',
	'LIVE_bar_named_numbered': '%{name} 条形图（%{number} 个）',
	'LIVE_stacked_bar_has_mapping': '%{values} 堆积条形图',
	'LIVE_stacked_bar_has_mapping_numbered': '%{values} 堆积条形图（%{number} 个）',
	'LIVE_stacked_bar_opt_mapping': '%{categories}（按 %{values} 堆积条形图）',
	'LIVE_stacked_bar_opt_mapping_numbered': '%{categories}（按 %{values} 堆积条形图（%{number} 个））',
	'LIVE_stacked_bar_no_mapping': '空堆积条形图',
	'LIVE_stacked_bar_no_mapping_numbered': '空堆积条形图（%{number} 个）',
	'LIVE_stacked_bar_named': '%{name} 堆积条形图',
	'LIVE_stacked_bar_named_numbered': '%{name} 堆积条形图（%{number} 个）',
	'LIVE_bubble_has_mapping': '%{categories}（按 %{x} 和 %{y} 气泡图）',
	'LIVE_bubble_has_mapping_numbered': '%{categories}（按 %{x} 和 %{y} 气泡图（%{number} 个））',
	'LIVE_bubble_no_mapping': '空气泡图',
	'LIVE_bubble_no_mapping_numbered': '空气泡图（%{number} 个）',
	'LIVE_bubble_named': '%{name} 气泡图',
	'LIVE_bubble_named_numbered': '%{name} 气泡图（%{number} 个）',
	'LIVE_composite_has_mapping': '%{categories}（按 %{columnValue} 和 %{lineValue} 组合图表）',
	'LIVE_composite_has_mapping_numbered': '%{categories}（按 %{columnValue} 和 %{lineValue} 组合图表（%{number} 个）)',
	'LIVE_composite_no_mapping': '空组合图表',
	'LIVE_composite_no_mapping_numbered': '空组合图表（%{number} 个）',
	'LIVE_composite_named': '%{name} 组合图表',
	'LIVE_composite_named_numbered': '%{name} 组合图表（%{number} 个）',
	'LIVE_decision_tree_has_mapping': '%{values} 决策树',
	'LIVE_decision_tree_has_mapping_numbered': '%{values} 决策树（%{number} 个）',
	'LIVE_decision_tree_no_mapping': '空决策树',
	'LIVE_decision_tree_no_mapping_numbered': '空决策树（%{number} 个）',
	'LIVE_decision_tree_named': '%{name} 决策树',
	'LIVE_decision_tree_named_numbered': '%{name} 决策树（%{number} 个）',
	'LIVE_packed_bubble_has_mapping': '%{categories} 压缩气泡图',
	'LIVE_packed_bubble_has_mapping_numbered': '%{categories} 压缩气泡图（%{number} 个）',
	'LIVE_packed_bubble_no_mapping': '空压缩气泡图',
	'LIVE_packed_bubble_no_mapping_numbered': '空压缩气泡图（%{number} 个）',
	'LIVE_packed_bubble_named': '%{name} 压缩气泡图',
	'LIVE_packed_bubble_named_numbered': '%{name} 压缩气泡图（%{number} 个）',
	'LIVE_pie_has_mapping': '%{categories}（按 %{values} 饼图）',
	'LIVE_pie_has_mapping_numbered': '%{categories}（按 %{values} 饼图（%{number} 个））',
	'LIVE_pie_no_mapping': '空饼图',
	'LIVE_pie_no_mapping_numbered': '空饼图（%{number} 个）',
	'LIVE_pie_named': '%{name} 饼图',
	'LIVE_pie_named_numbered': '%{name} 饼图（%{number} 个）',
	'LIVE_pie_as_donut_has_mapping': '%{categories}（按 %{values} 圆环图）',
	'LIVE_pie_as_donut_has_mapping_numbered': '%{categories}（按 %{values} 圆环图（%{number} 个））',
	'LIVE_pie_as_donut_no_mapping': '空圆环图',
	'LIVE_pie_as_donut_no_mapping_numbered': '空圆环图（%{number} 个）',
	'LIVE_pie_as_donut_named': '%{name} 圆环图',
	'LIVE_pie_as_donut_named_numbered': '%{name} 圆环图（%{number} 个）',
	'LIVE_line_has_mapping': '%{categories}（按 %{values} 折线图）',
	'LIVE_line_has_mapping_numbered': '%{categories}（按 %{values} 折线图（%{number} 个））',
	'LIVE_line_no_mapping': '空折线图',
	'LIVE_line_no_mapping_numbered': '空折线图（%{number} 个）',
	'LIVE_line_named': '%{name} 折线图',
	'LIVE_line_named_numbered': '%{name} 折线图（%{number} 个）',
	'LIVE_area_has_mapping': '%{categories}（按 %{values} 面积图）',
	'LIVE_area_has_mapping_numbered': '%{categories}（按 %{values} 面积图（%{number} 个））',
	'LIVE_area_no_mapping': '空面积图',
	'LIVE_area_no_mapping_numbered': '空面积图（%{number} 个）',
	'LIVE_area_named': '%{name} 面积图',
	'LIVE_area_named_numbered': '%{name} 面积图（%{number} 个）',
	'LIVE_area_as_stacked_percent_has_mapping': '%{categories}（按 %{values} 堆积百分比面积图）',
	'LIVE_area_as_stacked_percent_has_mapping_numbered': '%{categories}（按 %{values} 堆积百分比面积图（%{number} 个））',
	'LIVE_area_as_stacked_percent_no_mapping': '空堆积百分比面积图',
	'LIVE_area_as_stacked_percent_no_mapping_numbered': '空堆积百分比面积图（%{number} 个）',
	'LIVE_area_as_stacked_percent_named': '%{name} 堆积百分比面积图',
	'LIVE_area_as_stacked_percent_named_numbered': '%{name} 堆积百分比面积图（%{number} 个）',
	'LIVE_heatmap_has_mapping': '%{color} 热图',
	'LIVE_heatmap_has_mapping_numbered': '%{color} 热图（%{number} 个）',
	'LIVE_heatmap_no_mapping': '空热图',
	'LIVE_heatmap_no_mapping_numbered': '空热图（%{number} 个）',
	'LIVE_heatmap_named': '%{name} 热图',
	'LIVE_heatmap_named_numbered': '%{name} 热图（%{number} 个）',
	'LIVE_network_opt_mapping': '%{categories}（按 %{series} 和 %{values} 网络）',
	'LIVE_network_opt_mapping_numbered': '%{categories}（按 %{series} 和 %{values} 网络（%{number} 个））',
	'LIVE_network_has_mapping': '%{categories}（按 %{series} 网络）',
	'LIVE_network_has_mapping_numbered': '%{categories}（按 %{series} 网络（%{number} 个））',
	'LIVE_network_no_mapping': '空网络',
	'LIVE_network_no_mapping_numbered': '空网络（%{number} 个）',
	'LIVE_network_named': '%{name} 网络',
	'LIVE_network_named_numbered': '%{name} 网络（%{number} 个）',
	'LIVE_radial_bar_opt_mapping': '%{categories}（按 %{values} 径向条形图）',
	'LIVE_radial_bar_opt_mapping_numbered': '%{categories}（按 %{values} 径向条形图（%{number} 个））',
	'LIVE_radial_bar_has_mapping': '%{values} 径向条形图',
	'LIVE_radial_bar_has_mapping_numbered': '%{values} 径向条形图（%{number} 个）',
	'LIVE_radial_bar_no_mapping': '空径向条形图',
	'LIVE_radial_bar_no_mapping_numbered': '空径向条形图（%{number} 个）',
	'LIVE_radial_bar_named': '%{name} 径向条形图',
	'LIVE_radial_bar_named_numbered': '%{name} 径向条形图（%{number} 个）',
	'LIVE_spiral_has_mapping': '%{values} 螺旋图',
	'LIVE_spiral_has_mapping_numbered': '%{values} 螺旋图（%{number} 个）',
	'LIVE_spiral_no_mapping': '空螺旋图',
	'LIVE_spiral_no_mapping_numbered': '空螺旋图（%{number} 个）',
	'LIVE_spiral_named': '%{name} 螺旋图',
	'LIVE_spiral_named_numbered': '%{name} 螺旋图（%{number} 个）',
	'LIVE_treemap_has_mapping': '%{categories}（按 %{size} 树状图）',
	'LIVE_treemap_has_mapping_numbered': '%{categories}（按 %{size} 树状图（%{number} 个））',
	'LIVE_treemap_no_mapping': '空树状图',
	'LIVE_treemap_no_mapping_numbered': '空树状图（%{number} 个）',
	'LIVE_treemap_named': '%{name} 树状图',
	'LIVE_treemap_named_numbered': '%{name} 树状图（%{number} 个）',
	'LIVE_wordcloud_has_mapping': '%{categories} 字云',
	'LIVE_wordcloud_has_mapping_numbered': '%{categories} 字云（%{number} 个）',
	'LIVE_wordcloud_no_mapping': '空字云',
	'LIVE_wordcloud_no_mapping_numbered': '空字云（%{number} 个）',
	'LIVE_wordcloud_named': '%{name} 字云',
	'LIVE_wordcloud_named_numbered': '%{name} 字云（%{number} 个）',
	'LIVE_data_player_has_mapping': '%{category} 数据播放器',
	'LIVE_data_player_has_mapping_numbered': '%{category} 数据播放器（%{number} 个）',
	'LIVE_data_player_no_mapping': '空数据播放器',
	'LIVE_data_player_no_mapping_numbered': '空数据播放器（%{number} 个）',
	'LIVE_data_player_named': '%{name} 数据播放器',
	'LIVE_data_player_named_numbered': '%{name} 数据播放器（%{number} 个）',
	'LIVE_map_has_mapping': '%{locations} 地图',
	'LIVE_map_has_mapping_numbered': '%{locations} 地图（%{number} 个）',
	'LIVE_map_no_mapping': '空地图',
	'LIVE_map_no_mapping_numbered': '空地图（%{number} 个）',
	'LIVE_map_named': '%{name} 地图',
	'LIVE_map_named_numbered': '%{name} 地图（%{number} 个）',
	'LIVE_point_has_mapping': '%{categories}（按 %{values} 点状图）',
	'LIVE_point_has_mapping_numbered': '%{categories}（按 %{values} 点状图（%{number} 个））',
	'LIVE_point_no_mapping': '空点状图',
	'LIVE_point_no_mapping_numbered': '空点状图（%{number} 个）',
	'LIVE_point_named': '%{name} 点状图',
	'LIVE_point_named_numbered': '%{name} 点状图（%{number} 个）',
	'LIVE_column_has_mapping': '%{values} 柱形图',
	'LIVE_column_has_mapping_numbered': '%{values} 柱形图（%{number} 个）',
	'LIVE_column_opt_mapping': '%{categories}（按 %{values} 柱形图）',
	'LIVE_column_opt_mapping_numbered': '%{categories}（按 %{values} 柱形图（%{number} 个））',
	'LIVE_column_no_mapping': '空柱形图',
	'LIVE_column_no_mapping_numbered': '空柱形图（%{number} 个）',
	'LIVE_column_named': '%{name} 柱形图',
	'LIVE_column_named_numbered': '%{name} 柱形图（%{number} 个）',
	'LIVE_stacked_column_has_mapping': '%{values} 堆积柱形图',
	'LIVE_stacked_column_has_mapping_numbered': '%{values} 堆积柱形图（%{number} 个）',
	'LIVE_stacked_column_opt_mapping': '%{categories}（按 %{values} 堆积柱形图）',
	'LIVE_stacked_column_opt_mapping_numbered': '%{categories}（按 %{values} 堆积柱形图（%{number} 个））',
	'LIVE_stacked_column_no_mapping': '空堆积柱形图',
	'LIVE_stacked_column_no_mapping_numbered': '空堆积柱形图（%{number} 个）',
	'LIVE_stacked_column_named': '%{name} 堆积柱形图',
	'LIVE_stacked_column_named_numbered': '%{name} 堆积柱形图（%{number} 个）',
	'LIVE_scatter_opt_mapping': '%{categories}（按 %{x} 和 %{y} 散点图）',
	'LIVE_scatter_opt_mapping_numbered': '%{categories}（按 %{x} 和 %{y} 散点图（%{number} 个）)',
	'LIVE_scatter_has_mapping': '%{x} 与 %{y} 散点图',
	'LIVE_scatter_has_mapping_numbered': '%{x} 与 %{y} 散点图（%{number} 个）',
	'LIVE_scatter_no_mapping': '空散点图',
	'LIVE_scatter_no_mapping_numbered': '空散点图（%{number} 个）',
	'LIVE_scatter_named': '%{name} 散点图',
	'LIVE_scatter_named_numbered': '%{name} 散点图（%{number} 个）',
	'LIVE_waterfall_has_mapping': '%{values} 瀑布图',
	'LIVE_waterfall_has_mapping_numbered': '%{values} 瀑布图（%{number} 个）',
	'LIVE_waterfall_no_mapping': '空瀑布图',
	'LIVE_waterfall_no_mapping_numbered': '空瀑布图（%{number} 个）',
	'LIVE_waterfall_named': '%{name} 瀑布图',
	'LIVE_waterfall_named_numbered': '%{name} 瀑布图（%{number} 个）',
	'LIVE_empty_visualization_hint_title': '构建可视化',
	'LIVE_empty_visualization_hint_description': '将列拖放到此处或向左拖放到时段上。',
	'LIVE_slots_required_field_description': '%{asterisk} 指示必填字段',
	'LIVE_slots_drag_and_drop_description': '将数据拖放到时段上方可构建并过滤可视化。',
	'requiredField': '必填字段',
	'fullScreenEnter': '进入全屏',
	'fullScreenClose': '退出全屏',
	'noExtraText_multipurpose': '多用途占位符',
	'noExtraText_multipurpose_numbered': '多用途占位符（%{number} 个）',
	'one_placeholder_vis': '可视化占位符',
	'one_placeholder_vis_numbered': '可视化占位符（%{number} 个）',
	'one_placeholder_text': '文本占位符',
	'one_placeholder_text_numbered': '文本占位符（%{number} 个）',
	'few_placeholder_text': '含有 %{count} 个文本占位符的组',
	'many_placeholder_text': '含有 %{count} 个文本占位符的组',
	'filter_includesAll': '全部包含',
	'timeline_filter_moved_to': '时间行过滤器 %{id} 已移至 %{time}',
	'timelineSettingsButton': '回放选项',
	'autoPlay': '播放所有场景',
	'loop': '循环',
	'noSceneTransitionLabel': '无',
	'sceneTransitionPropertyLabel': '场景转换',
	'animatedPathSceneTransitionLabel': '动画路径',
	'sweepSceneTransitionLabel': '清除',
	'propAniAnimation': '动画',
	'propAniTypeEntrance': '入口动画',
	'propAniDirectionIn': '入口方向',
	'propAniTypeExit': '出口动画',
	'propAniDirectionOut': '出口方向',
	'propAniDirection': '方向',
	'timelineAnimationProperties': '打开动画属性',
	'editStoryCoachMarkTitle': '编辑案例',
	'editStoryCoachMarkContents': '单击画笔图标以编辑此案例。',
	'addDataStoryCoachMarkContents': '将数据从数据面板拖放到案例上。',
	'expandSceneCoachmarkTitle': '打开时间线',
	'expandSceneCoachmarkContents': '通过根据时间和持续时间调整对象可视性来制作场景动画。',
	'overviewCoachmarkTitle': '概述场景',
	'overviewCoachmarkContents': '在案例的开头和结尾使用概述场景来显示所有场景的重点。从概述场景中，单击并拖动场景可将其与其他场景交换。您可以在案例属性中显示或隐藏概述场景。',
	'animatedPathCoachmarkTitle': '动画路径',
	'animatedPathCoachmarkContents': '要通过动画形式将对象从一个场景移动到另一个场景，请连带对象复制场景。然后，对新场景上复制的对象进行移动、大小调整或旋转。',
	'tabName_animation': '动画',
	'textWidgetIconPlaceholderText': '单击以添加文本',
	'visIconPlaceholderText': '拖放数据以构建可视化',
	'launchNewExplore': '新建探索',
	'addTo': '添加到',
	'addToExisting': '添加到现有项...',
	'exploreData': '探索',
	'explore_remove_widget_styles': '自定义可视化属性（例如，颜色设置）不会在探索中持久存储。',
	'editNotebook': '编辑窗口小部件',
	'thumbnails_error_fetching': '访存缩略图时出错',
	'copy': '%{count} 个资产已复制',
	'specConvertErr': '粘贴或转换仪表板规范时发生错误',
	'specCopyErr': '复制仪表板规范时出错',
	'pasteNotSupportedErr': '不支持从 %{name} 进行粘贴。',
	'reportParam': '报表',
	'filterWidgetCopyWarn': '未复制过滤器可视化，因为此时不支持过滤器。',
	'upgradingDashboard': '正在升级 %{version} 的“%{name}”...',
	'upgradeComplete': '升级完成',
	'individualTabProperties': '单个选项卡属性',
	'propMasterTabStylesLabel': '主选项卡样式',
	'propTabPosition': '选项卡位置',
	'propTabTitle': '标题',
	'propTabBackgroundColor': '填充颜色',
	'propTabTextColor': '轴名颜色',
	'propTabSelectedBarColor': '所选条形颜色',
	'propTabRestoreDefaults': '复原默认值',
	'propIndividualTabStylesLabel': '单个选项卡样式',
	'propIndividualTabStylesAriaLabel': '打开单个选项卡样式属性',
	'propTabIconPosition': '图标位置',
	'propLeftTitle': '标题左侧',
	'propRightTitle': '标题右侧',
	'propTopTitle': '标题上方',
	'propBottomTitle': '标题下方',
	'propTabIconLabel': '可视',
	'propTabIcon': '图标',
	'propTabIconColor': '图标颜色',
	'no_icon': '空白',
	'announcement': '通知',
	'api': 'API',
	'archive': '归档',
	'asset': '资产',
	'attachment': '附件',
	'audio': '音频',
	'bee': '蜜蜂',
	'blog': '博客',
	'bookmark': '书签',
	'calendar': '日历',
	'camera': '相机',
	'capability': '功能',
	'catalog': '目录',
	'chat_message': '交谈消息',
	'checkout_cart': '结帐购物车',
	'client': '客户端',
	'clock': '时钟',
	'cloud': '云',
	'code': '代码',
	'data_quality': '数据质量',
	'folder': '文件夹',
	'forum': '论坛',
	'glasses': '眼镜',
	'group': '分组',
	'hat': '帽子',
	'headphone': '耳机',
	'hills': '山岗',
	'home': '主页',
	'idea': '观点',
	'image': '图像',
	'inventory': '清单',
	'like': '喜欢',
	'link': '链接',
	'location': '位置',
	'manage': '管理',
	'pen': '画笔',
	'mobile_phone': '移动电话',
	'music': '音乐',
	'notifications': '通知',
	'paint': '画图',
	'payment': '付款',
	'password_key': '密码钥匙',
	'people': '人员',
	'person': '个人',
	'phone': '电话',
	'pin': '置顶',
	'print': '打印',
	'recording': '记录',
	'repository': '存储库',
	'role': '角色',
	'search': '搜索',
	'properties': '属性',
	'speaker': '扬声器',
	'star': '星形',
	'tag': '标记',
	'thumbs_up': '赞成',
	'thumbs_down': '不赞成',
	'tools': '工具',
	'traffic': '交通',
	'trash': '废纸篓',
	'twitter': 'Twitter',
	'unknown': '未知',
	'user': '用户',
	'venn_diagram': 'Venn 图',
	'video': '视频',
	'view': '视图',
	'warning': '警告',
	'watch': '监控',
	'watson': 'Watson',
	'wikis': 'Wiki',
	'workspace': '工作空间',
	'world': '世界',
	'OnLoadFilterModifierDatasourceMismatch': '过滤器不会应用于目标，因为仪表板使用的是不同的源。',
	'OnLoadFilterModifierColumnMismatch': '未应用一个或多个过滤器，因为找不到匹配的列。',
	'eventGroupButtonLabel': '查看窗口小部件连接',
	'dockToolbar': '悬停工具栏',
	'undockToolbar': '取消悬停工具栏',
	'propShowTitle': '显示标题'
});
